<template>
  <v-card class="tracking-note">
    <v-card-text style="border: 1px solid black">
      <v-layout row wrap>
        <v-flex xs12>
          <v-autocomplete
            v-model="note.consultant_id"
            :items="consultantList"
            :label="$t('Asesor/a')"
            :rules="[rules.required]"
            chips
            disabled
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md6 class="pa-3">
          <v-menu
            v-model="showNoteDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="date"
                v-model="formattedTrackingNoteDate"
                class="pr-2"
                label="Fecha"
                readonly
                v-on="on"
                :rules="[rules.required]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="note.date"
              @input="showNoteDatePicker = false"
              locale="es"
              first-day-of-week="1"
              :reactive="true"
              :rules="[rules.required]"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md6 class="pa-3">
          <v-checkbox v-model="note.pending_actions" label="Acción pendiente"></v-checkbox>
        </v-flex>
        <v-flex xs12 class="pa-3">
          <v-textarea
            v-model="note.note"
            :label="$t('Anotación')"
            auto-grow
            rows="4"
            :rules="[rules.required]"
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CustomerTrackingNote',
  props: ['index', 'trackingNote', 'consultantList'],
  data() {
    return {
      showNoteDatePicker: false,
      note: {
        id: null,
        customer_tracking_id: null,
        note: null,
        date: null,
        consultant_id: null,
        pending_actions: false,
      },
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
      },
    };
  },
  computed: {
    formattedTrackingNoteDate() {
      return this.note.date ? moment(this.note.date).format('DD/MM/YYYY') : '';
    },
    trackingNoteKey() {
      return `${this.note.date}-${this.note.consultant_id}-${this.note.note}-${
        this.note.pending_actions
      }`;
    },
  },
  mounted() {
    if (this.trackingNote) {
      this.note = this.trackingNote;
    }
  },
  watch: {
    trackingNoteKey() {
      this.$emit('note-changed', { index: this.index, note: this.note });
    },
  },
};
</script>

<style scoped></style>
